"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordCredentialsToJSON = exports.PasswordCredentialsFromJSONTyped = exports.PasswordCredentialsFromJSON = void 0;
function PasswordCredentialsFromJSON(json) {
    return PasswordCredentialsFromJSONTyped(json, false);
}
exports.PasswordCredentialsFromJSON = PasswordCredentialsFromJSON;
function PasswordCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': json['email'],
        'password': json['password'],
    };
}
exports.PasswordCredentialsFromJSONTyped = PasswordCredentialsFromJSONTyped;
function PasswordCredentialsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'password': value.password,
    };
}
exports.PasswordCredentialsToJSON = PasswordCredentialsToJSON;
//# sourceMappingURL=PasswordCredentials.js.map